import gql from "graphql-tag";

import { FRAGMENT_QUESTION } from "../../../../graphql/gqlFragments";

export const PROPERTY_TYPES = gql`
  query getTypes {
    propertyTypes {
      id
      name
      image
      forSeller
      types
      filters {
        tagId
        value
      }
    }
  }
`;

export const QUESTION_BACKGROUNDS = gql`
  query getQuestionBackgrounds {
    sliderBackgrounds {
      image
    }
  }
`;

export const QUESTIONS = gql`
  query getQuestions($propertyTypeId: Int!) {
    questions(propertyTypeId: $propertyTypeId) {
      ...QuestionFields
    }
  }
  ${FRAGMENT_QUESTION}
`;

export const QUESTIONARY_PARSAMS = gql`
  query sendAnswers(
    $address: AddressHash!
    $page: Int!
    $perPage: Int
    $sort: String!
    $filters: [SearchHash!]
  ) {
    properties(
      address: $address
      page: $page
      sort: $sort
      filters: $filters
      perPage: $perPage
    ) {
      entities {
        id
        score
        listPrice
        gAddress
        roomInfo
        # bedrooms
        # bathrooms
        coordinates
        # pricePerSqft
        # roof
        # cooling
        # heating
        # bathsFull
        city
        street
        photos {
          image
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      address {
        placeId
        description
        type
      }
    }
  }
`;

export const GET_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        type
        placeId
        mainText
        secondaryText
      }
    }
  }
`;

export const GET_ADDRESSES = gql`
  query addresses($input: String!) {
    addresses(input: $input) {
      type
      places {
        description
        type
        placeId
        mainText
        secondaryText
      }
    }
  }
`;
